angular.module('rightPaneModule')
  .service('dblPrintAllStudentsModalService', [function () {
    var self = this;
  }]);